import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNDrug extends CNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNDrug';
    }

    get name() {
        return this.getProperty('fr');
    }

    public clone(): any {
        return new CNDrug();
    }
}
